import "core-js/modules/es.promise.finally.js";
import { jsx, jsxs } from 'react/jsx-runtime';
import { Modal, Text, Row, Column, Table, Button } from '@dls/web';
import { SearchInput, Container, TableWrapper, NoResultsFound, ErrorSlate } from '@geit/ui-components';
import { useState, useEffect, useMemo, useCallback } from 'react';
import { getBrnTableConfig } from './service.js';
import '../../../../../../../authentication/context/AuthenticationProvider.js';
import { useCurrentUser } from '../../../../../../../authentication/hooks/useCurrentUser.js';
import { useNavigate } from '../../../../../../../authentication/hooks/useNavigate.js';
import 'qs';
import 'uuid';
import '../../../../../../../authentication/navigate.js';
import { useUserDomains } from '../../../../../../../authentication/hooks/useUserDomains.js';
import { DomainType } from '../../../../../../../authentication/types/User.js';
import { SCContainerStyledComponent } from '../../../../../../StyleComponents/SCContainerStyledComponent.js';
import { SCDivStyledComponent } from '../../../../../../StyleComponents/SCDivStyledComponents.js';
import '../../../../../../StyleComponents/SCTextStyledComponent.js';
import { Margin, TextCenter } from '../../../../../../StyleComponents/style.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
const debounce = function (func) {
  let wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  let timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
const EntitySelectionModal = _ref => {
  let {
    visible,
    setVisible,
    onApplyChange
  } = _ref;
  const navigate = useNavigate();
  const [validationMsg, setValidationMsg] = useState("");
  const [serverError, setServerError] = useState(void 0);
  const [entityListDisplay, setEntityListDisplay] = useState();
  const {
    user
  } = useCurrentUser();
  const {
    domains: entityList,
    setUserDomain
  } = useUserDomains();
  const [selectedBrn, setSelectedBrn] = useState(user.entitySelection);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (entityList == null ? void 0 : entityList.length) {
      if (!user.entitySelection || !user.entitySelection.refNumber) {
        if (entityList.length) {
          setUserDomain == null ? void 0 : setUserDomain(entityList[0]);
          setSelectedBrn(entityList[0]);
        }
      } else {
        setSelectedBrn(user.entitySelection);
      }
      setEntityListDisplay(entityList);
    }
  }, [entityList, setUserDomain, user.entitySelection]);
  const onSelect = entitySelection => {
    setSelectedBrn(entitySelection ? entitySelection : {
      id: 0,
      refNumber: "",
      domainType: DomainType.BRN,
      customerId: 0,
      sector: ""
    });
    if (entitySelection) {
      setValidationMsg("");
    }
  };
  const {
    columns,
    rowSelection
  } = useMemo(() => getBrnTableConfig(selectedBrn == null ? void 0 : selectedBrn.refNumber, onSelect), [selectedBrn]);
  const handleSave = () => {
    setValidationMsg("");
    if (selectedBrn && selectedBrn.id !== 0) {
      setLoading(true);
      setUserDomain == null ? void 0 : setUserDomain(selectedBrn).then(() => {
        setVisible(false);
        setEntityListDisplay(entityList);
        onApplyChange == null ? void 0 : onApplyChange(selectedBrn);
        navigate("/");
      }).catch(error => setServerError(error)).finally(() => {
        setLoading(false);
      });
    } else {
      setValidationMsg("Please select BRN to proceed.");
    }
  };
  const onClose = () => {
    setVisible(false);
    setSelectedBrn(user.entitySelection);
    setEntityListDisplay(entityList);
  };
  const onDebouncedSearch = debounce(useCallback(event => {
    if (entityList == null ? void 0 : entityList.length) {
      const searchTerm = event.target.value.trim().toLowerCase();
      setEntityListDisplay(entityList.filter(item => {
        var _a;
        return item.refNumber.toLowerCase().indexOf(searchTerm) !== -1 || ((_a = item.companyName) == null ? void 0 : _a.toLowerCase().indexOf(searchTerm)) !== -1;
      }));
    }
  }, [entityList]));
  return /* @__PURE__ */jsx(Modal, {
    visible,
    title: "Switch to another BRN account",
    wide: true,
    onClose,
    children: /* @__PURE__ */jsxs(Modal.Content, {
      children: [/* @__PURE__ */jsx(Text, {
        children: "Select the Business Registration Number (BRN) account that you would like to view for."
      }), /* @__PURE__ */jsx(Row, {
        children: /* @__PURE__ */jsx(Column, {
          xs: 12,
          md: 6,
          children: /* @__PURE__ */jsx(SCDivStyledComponent, {
            css: Margin("y", 2),
            children: /* @__PURE__ */jsx(SearchInput, {
              bgColor: "haze",
              label: "Search",
              onChange: onDebouncedSearch
            })
          })
        })
      }), /* @__PURE__ */jsx(Container, {
        children: /* @__PURE__ */jsx(TableWrapper, {
          noCheckAll: true,
          children: entityListDisplay && entityListDisplay.length ? /* @__PURE__ */jsx(Table, {
            rowSelection,
            columns,
            data: entityListDisplay
          }) : /* @__PURE__ */jsx(NoResultsFound, {})
        })
      }), /* @__PURE__ */jsxs(SCContainerStyledComponent, {
        css: __spreadValues(__spreadValues({}, TextCenter), Margin("t", 5)),
        children: [/* @__PURE__ */jsx(ErrorSlate, {
          error: serverError,
          errorMessages: [validationMsg],
          setError: null
        }), /* @__PURE__ */jsx(Button, {
          onClick: handleSave,
          loading: loading ? "inProgress" : false,
          children: "Apply changes"
        })]
      })]
    })
  });
};
export { EntitySelectionModal as default };